/**
 * SPRINT V2 — Rivalidades Activas.
 * Derives "live" rivalries from a static catalogue + a deterministic
 * daily pulse so the surface feels alive without backend wiring.
 */
import { nationMeta } from "./nationImpact";

export interface ActiveRivalry {
  id: string;
  left: string;
  right: string;
  leftScore: number;
  rightScore: number;
  heat: number; // 0..1
  label: string;
}

const PAIRS: Array<[string, string]> = [
  ["MEX", "USA"],
  ["ARG", "BRA"],
  ["ESP", "POR"],
  ["COL", "ARG"],
  ["FRA", "ESP"],
];

function dayHash(seed: string): number {
  const d = new Date();
  const k = `${seed}-${d.getUTCFullYear()}-${d.getUTCMonth()}-${d.getUTCDate()}`;
  let h = 0;
  for (let i = 0; i < k.length; i++) h = (h * 31 + k.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function listActiveRivalries(userNation: string | null): ActiveRivalry[] {
  const out: ActiveRivalry[] = [];
  for (const [a, b] of PAIRS) {
    const h = dayHash(`${a}-${b}`);
    const left = 40 + (h % 60);
    const right = 40 + ((h >> 3) % 60);
    const heat = Math.min(1, (Math.abs(left - right) + 20) / 100);
    const involved = userNation && (userNation === a || userNation === b);
    out.push({
      id: `${a}-${b}`,
      left: a,
      right: b,
      leftScore: left,
      rightScore: right,
      heat,
      label: involved ? "Tu nación está en juego" : "Rivalidad activa",
    });
  }
  return out.sort((x, y) => {
    const xi = userNation && (x.left === userNation || x.right === userNation) ? 1 : 0;
    const yi = userNation && (y.left === userNation || y.right === userNation) ? 1 : 0;
    if (xi !== yi) return yi - xi;
    return y.heat - x.heat;
  });
}

export function rivalryDisplay(r: ActiveRivalry) {
  const total = Math.max(1, r.leftScore + r.rightScore);
  return {
    leftMeta: nationMeta(r.left)!,
    rightMeta: nationMeta(r.right)!,
    leftPct: Math.round((r.leftScore / total) * 100),
    rightPct: Math.round((r.rightScore / total) * 100),
  };
}